// Extending From
import Service from '@ember/service';
// Ember Imports
import { service } from '@ember/service';

const successOptions = {
  duration: 4000,
  position: 'top right',
  toastClass: 'success',
};

const errorOptions = {
  duration: 6000,
  position: 'top right',
  toastClass: 'warning',
};

const showOptions = {
  duration: 4000,
  position: 'top right',
};

/**
 * toaster wraps paper-toaster so we don't have to push options in every time.
 */
export default class ToasterService extends Service {
  // Services
  @service
  paperToaster;

  // success provides a success toast message.
  success(msg) {
    this.paperToaster.show(msg, successOptions);
  }

  // error provides an error toast message.
  error(msg) {
    this.paperToaster.show(msg, errorOptions);
  }

  // show provides a paper-toaster wrapper around the underlying 'show' method.
  show(msg, options) {
    this.paperToaster.show(msg, options);
  }

  // show provides a paper-toaster wrapper around the show message but with pre-defined options
  message(msg) {
    this.paperToaster.show(msg, showOptions);
  }
}
